import React from 'react';
import './CustomIcon.css';

const CustomIcon = ({ digit = 1 }) => {
  return <div className="CustomIcon">{digit}</div>;
};

export default CustomIcon;



// WEBPACK FOOTER //
// ./src/components/Actions/SplitReport/SplitReport_SingleSample/CustomIcon.jsx